class Breadcrumbs
    constructor: (el) ->
        @.$el = el
        @.$firstItem = @.$el.querySelector '.breadcrumbs__item'
        @.$listEl = @.$el.querySelector 'ol'

        @.itemClasses = if @.$firstItem then @.$firstItem.classList else false

        @.$el.classList.add 'breadcrumbs--bound'
        @.InitEvents()
        return
    
    AddBreadcrumbLink: (link, text) ->
        itemEl = document.createElement 'li'
        if @.itemClasses
            itemEl.classList = @.itemClasses
        else
            itemEl.classList.add 'breadcrumbs__item', 'icon-arrow-after'
        itemEl.innerHTML = "
            <a href='#{ link ? "#" }'>
                <span class='breadcrumbs__item-text'>#{ text ? "Aktuelle Seite" }</span>
            </a>
        "
        @.$listEl.appendChild itemEl
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'breadcrumbs-add', (e) ->
            items = e.detail?.items ? []
            items.forEach (item) ->
                self.AddBreadcrumbLink item.link, item.text
                return
            return
        return
    
BindBreadcrumbs = ->
    document.querySelectorAll '.breadcrumbs:not(.breadcrumbs--bound)'
        .forEach (el) ->
            new Breadcrumbs el
            return
    return

window.addEventListener 'bind-components', BindBreadcrumbs